// Gemeinsame Optik der schwebenden Listen (Select, DropdownMenu, Combobox, MentionPopover):
// Fläche `overlay`, `shadow-2`, Radius 12; Einträge mit Hover/Fokus-Fläche `tile` (DESIGN §3.6.5, §3.7.4).
import { cn } from '../../basis/kern';

export const floatingSurface = cn(
  'bar-st-pop z-(--bar-z-popover) rounded-lg bg-overlay text-fg shadow-2',
  '[[data-theme=light]_&]:border [[data-theme=light]_&]:border-line-subtle',
);

export const menuItemBase =
  'relative flex min-h-9 w-full cursor-default items-center gap-3 rounded-sm px-3 py-2 text-left text-button text-fg outline-none select-none';

/** Radix-Einträge: data-highlighted / data-disabled (leer gesetzt). */
export const menuItem = cn(
  menuItemBase,
  'data-[highlighted]:bg-tile data-[disabled]:cursor-not-allowed data-[disabled]:text-fg-disabled',
);

/** cmdk-Einträge: data-selected="true" / data-disabled="true|false". */
export const cmdkItem = cn(
  menuItemBase,
  'data-[selected=true]:bg-tile data-[disabled=true]:cursor-not-allowed data-[disabled=true]:text-fg-disabled',
);

export const menuGroupLabel = 'px-3 pt-2 pb-1 text-chip text-fg-tertiary';

export const menuSeparator = 'mx-1 my-1 h-px bg-line-subtle';
